/* eslint-disable no-console */
import axios from 'axios'
import { Service } from 'axios-middleware'

const service = axios.create({
  baseURL: process.env.VUE_APP_REST_URL,
  headers: { 'Content-type': 'application/json', Accept: 'application/json' }
})

const middlewareService = new Service(service)

middlewareService.register({
  onResponseError(error) {
    return new Promise((resolve, reject) => {
      if (process.env.NODE_ENV === 'production') {
        return reject(error)
      }
      // DEV mode
      if (error.response) {
        console.log(error.response)
        reject(error.response)
      } else {
        console.log(error)
        reject(error)
      }
    })
  }
})

export { service as axios, middlewareService as axiosMiddlewareService }
